import React from 'react';

/**
 * Alignment Guides Component
 * Shows alignment lines when dragging/resizing areas
 */
const AlignmentGuides = ({ 
    enabled, 
    color = '#8b5cf6',
    opacity = 0.8,
    width,
    height,
    guides = []
}) => {
    if (!enabled || guides.length === 0) return null;

    return (
        <svg
            className="absolute inset-0 pointer-events-none z-30"
            width={width}
            height={height}
            style={{ opacity }}
        >
            {guides.map((guide, index) => {
                if (guide.type === 'vertical') {
                    return (
                        <g key={`guide-${index}`}>
                            <line
                                x1={guide.position}
                                y1={0}
                                x2={guide.position}
                                y2={height}
                                stroke={color}
                                strokeWidth="2"
                                strokeDasharray="4 4"
                            />
                            <circle
                                cx={guide.position}
                                cy={height / 2}
                                r="4"
                                fill={color}
                            />
                        </g>
                    );
                } else if (guide.type === 'horizontal') {
                    return (
                        <g key={`guide-${index}`}>
                            <line
                                x1={0}
                                y1={guide.position}
                                x2={width}
                                y2={guide.position}
                                stroke={color}
                                strokeWidth="2"
                                strokeDasharray="4 4"
                            />
                            <circle
                                cx={width / 2}
                                cy={guide.position}
                                r="4"
                                fill={color}
                            />
                        </g>
                    );
                }
                return null;
            })}
            
            {/* Center guides */}
            <line
                x1={width / 2}
                y1={0}
                x2={width / 2}
                y2={height}
                stroke={color}
                strokeWidth="1"
                strokeDasharray="2 2"
                opacity="0.3"
            />
            <line
                x1={0}
                y1={height / 2}
                x2={width}
                y2={height / 2}
                stroke={color}
                strokeWidth="1"
                strokeDasharray="2 2"
                opacity="0.3"
            />
        </svg>
    );
};

export default AlignmentGuides;
